export default __webpack_public_path__ + "static/media/080_finish_soso.673e2806.mp4";